import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PartnerGuard({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: '3rem' }}>🌳</div>
  );
  if (!user) return <Navigate to="/join" replace />;
  if (!user.isPartner && !user.isAdmin) return <Navigate to="/" replace />;
  return children;
}
